'use client';

export const RightRailPromo = () => {
  return (
    <div
      className='flex justify-center items-center [&_iframe]:ml-0 w-(--max-rail-article-width) h-[125px]'
      id='promo-piano-template-right-rail-container'
    />
  );
};
